import styled from 'styled-components';

export const DetailNoticeWrapper = styled.div``;
